"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveApp = exports.queryEnableMigrate = exports.setMoveUSSetSSN = exports.useMoveUSOrderCountInfo = exports.useMoveUSCoinsNeedSell = exports.useUSEnableSymbolStrings = exports.USSymbolStringsObservable = exports.MoveUSSellCoin = void 0;
const react_1 = require("react");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const MoveUSBotOrders_1 = require("./MoveUSBotOrders");
const MoveUSFinanceOrders_1 = require("./MoveUSFinanceOrders");
const MoveUSManualOrders_1 = require("./MoveUSManualOrders");
const rxjs_1 = require("rxjs");
const operators_2 = require("rxjs/operators");
const TradeAPILib_1 = require("TradeAPILib");
const MoveUSSellCoin = (tradeAPI, coin, amount, symbolMap) => {
    // 获取最终需要交易的交易对
    const swapToUSDTSymbol = () => {
        const base = coin.base;
        let avaliableSymbol;
        if (symbolMap.get(`${base}/USDT`)) {
            avaliableSymbol = symbolMap.get(`${base}/USDT`);
            // 是USDT的幣對直接返回
            return (0, rxjs_1.of)({
                symbol: avaliableSymbol,
                amount: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(amount, avaliableSymbol.amount || 8),
            });
        }
        else if (symbolMap.get(`${base}/BUSD`)) {
            avaliableSymbol = symbolMap.get(`${base}/BUSD`);
        }
        else if (symbolMap.get(`${base}/BTC`)) {
            avaliableSymbol = symbolMap.get(`${base}/BTC`);
        }
        else if (symbolMap.get(`${base}/ETH`)) {
            avaliableSymbol = symbolMap.get(`${base}/ETH`);
        }
        else {
            return (0, rxjs_1.throwError)({ code: -1, message: base + " not support trade" });
        }
        return (0, rxjs_1.of)({
            symbol: avaliableSymbol,
            amount: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(amount, avaliableSymbol.amount || 8),
        }).pipe((0, operators_2.flatMap)(({ symbol, amount }) => {
            // 轉換成支持USDT的幣對
            const request = {
                marketParam: {
                    base: symbol.base,
                    quote: symbol.quote,
                    side: TradeAPILib_1.ExchangeOrderSide.sell,
                    type: TradeAPILib_1.ExchangeOrderType.market,
                    amount: amount,
                },
            };
            return tradeAPI.createOrderObservable(request).pipe((0, operators_2.delay)(1000), (0, operators_2.flatMap)((res) => {
                if (res.status !== 0) {
                    throw { code: res.status, message: JSON.stringify(res) };
                }
                return tradeAPI.queryCustomOrderPage({ orderId: res.orderId, limit: 1 }, false);
            }), (0, operators_1.map)((res) => {
                var _a;
                if (!res.length) {
                    throw { code: -2, message: "order not found" };
                }
                const order = res[0];
                const newSymbol = `${order.quote}/USDT`;
                const symbolData = symbolMap.get(newSymbol);
                if (!symbolData) {
                    throw { code: -3, message: "not found changed symbol: " + newSymbol };
                }
                // 成交额
                const newAmount = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr((_a = order.exchangeCustomOrder) === null || _a === void 0 ? void 0 : _a.filled_value, symbolData.amount || 8);
                if (!newAmount) {
                    throw { code: -4, message: "not found filled_value: " + JSON.stringify(order.exchangeCustomOrder) };
                }
                return { symbol: symbolData, amount: `${newAmount}` };
            }));
        }));
    };
    return swapToUSDTSymbol().pipe((0, operators_2.flatMap)((data) => {
        const request = {
            marketParam: {
                base: data.symbol.base,
                quote: data.symbol.quote,
                side: TradeAPILib_1.ExchangeOrderSide.sell,
                type: TradeAPILib_1.ExchangeOrderType.market,
                amount: data.amount,
            },
        };
        return tradeAPI.createOrderObservable(request);
    }));
};
exports.MoveUSSellCoin = MoveUSSellCoin;
const USSymbolStringsObservable = () => {
    // const url = "https://www.pionex.us/apis/papi/v1/spot_markets_us/";
    return trade_utils_lib_1.ObservableUtils.get((0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost + "/spot_markets_us/", undefined, undefined, false).pipe((0, operators_1.catchError)((error) => {
        console.log(error);
        throw error;
    }));
};
exports.USSymbolStringsObservable = USSymbolStringsObservable;
const useUSEnableSymbolStrings = () => {
    const [symbols, setSymbol] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        const $enableSymbols = (0, exports.USSymbolStringsObservable)()
            .pipe((0, operators_1.map)((res) => {
            return res.map((e) => e.symbol);
        }))
            .subscribe((res) => {
            setSymbol(res);
        }, (error) => { });
        return () => {
            $enableSymbols.unsubscribe();
        };
    }, []);
    return symbols;
};
exports.useUSEnableSymbolStrings = useUSEnableSymbolStrings;
const useMoveUSCoinsNeedSell = (balance) => {
    const [enableCoins, setEnableCoins] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const sub = (0, exports.USSymbolStringsObservable)().subscribe((res) => {
            const set = new Set();
            res.forEach((e) => {
                set.add(e.base);
                set.add(e.quote);
            });
            setEnableCoins(set);
        }, (error) => { });
        return () => {
            sub.unsubscribe();
        };
    }, []);
    return (0, react_1.useMemo)(() => {
        var _a;
        const large = [], small = [], tiny = [];
        if (!enableCoins) {
            return [large, small, tiny];
        }
        (_a = balance === null || balance === void 0 ? void 0 : balance.trade) === null || _a === void 0 ? void 0 : _a.balances.filter((res) => {
            return (enableCoins === null || enableCoins === void 0 ? void 0 : enableCoins.has(res.base)) === false;
        }).forEach((coinBalance) => {
            const value = new trade_utils_lib_1.SafeDecimal(coinBalance.available).mul(new trade_utils_lib_1.SafeDecimal(coinBalance.USDPrice));
            if (value.greaterThanOrEqualTo(500)) {
                large.push(coinBalance);
            }
            else if (value.lessThan(500) && value.greaterThanOrEqualTo(10)) {
                small.push(coinBalance);
            }
            else if (value.greaterThan(0)) {
                tiny.push(coinBalance);
            }
        });
        return [large, small, tiny];
    }, [balance, enableCoins]);
};
exports.useMoveUSCoinsNeedSell = useMoveUSCoinsNeedSell;
const useMoveUSOrderCountInfo = (tradeAPI, isFocused = true) => {
    const apiKey = tradeAPI === null || tradeAPI === void 0 ? void 0 : tradeAPI.getInnerApiKeyInfo();
    const botData = (0, MoveUSBotOrders_1.useMoveUSBotDataSource)(tradeAPI, undefined, undefined, isFocused);
    const manualData = (0, MoveUSManualOrders_1.useMoveUSManualDataSource)(tradeAPI, undefined, isFocused);
    const lendingData = (0, MoveUSFinanceOrders_1.useLendingPositions)(tradeAPI, isFocused);
    const fsaCount = (0, MoveUSFinanceOrders_1.useFSAOrderCount)(tradeAPI, isFocused);
    const keyInfo = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        return {
            exchange: (_a = apiKey === null || apiKey === void 0 ? void 0 : apiKey.market) !== null && _a !== void 0 ? _a : "",
            key_id: (_b = apiKey === null || apiKey === void 0 ? void 0 : apiKey.cloudKeyId) !== null && _b !== void 0 ? _b : "",
            alias: (_c = apiKey === null || apiKey === void 0 ? void 0 : apiKey.alias) !== null && _c !== void 0 ? _c : "",
        };
    }, [apiKey === null || apiKey === void 0 ? void 0 : apiKey.alias, apiKey === null || apiKey === void 0 ? void 0 : apiKey.cloudKeyId, apiKey === null || apiKey === void 0 ? void 0 : apiKey.market]);
    const structureCount = (0, MoveUSFinanceOrders_1.useStructureOrderCount)(keyInfo, isFocused);
    return (0, react_1.useMemo)(() => {
        if (botData.refreshing ||
            manualData.refreshing ||
            lendingData === undefined ||
            fsaCount === undefined ||
            structureCount === undefined) {
            return;
        }
        return {
            botCount: botData.dataSource.length,
            manualCount: manualData.dataSource.length,
            lendingCount: lendingData.length,
            fsaCount: fsaCount,
            structureCount: structureCount,
        };
    }, [
        botData.dataSource.length,
        botData.refreshing,
        fsaCount,
        lendingData,
        manualData.dataSource.length,
        manualData.refreshing,
        structureCount,
    ]);
};
exports.useMoveUSOrderCountInfo = useMoveUSOrderCountInfo;
const setMoveUSSetSSN = (ssn) => {
    const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost + "/user/save_kyc_ssn";
    return trade_utils_lib_1.ObservableUtils.postV2(url, { ssn: ssn }, undefined, true);
};
exports.setMoveUSSetSSN = setMoveUSSetSSN;
const queryEnableMigrate = (app) => {
    const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost + "/migration/query_enable_migrate_us";
    return trade_utils_lib_1.ObservableUtils.post(url, { migrate_to_app: app }, undefined, true);
};
exports.queryEnableMigrate = queryEnableMigrate;
const moveApp = (apiKey, app) => {
    const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost + "/migration/migrate";
    const token = {
        market: apiKey.exchange,
        cloudKeyId: apiKey.key_id,
    };
    return trade_utils_lib_1.ObservableUtils.postWithAccessAndSpotAuth(url, token, { migrate_to_app: app });
};
exports.moveApp = moveApp;
